export enum AnalyticsMode {
  Rows = 'ROWS',
  Groups = 'GROUPS',
}
